<template>
    <div>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="330px">
                <v-card>
                    <v-card-title>
                        <div class="mt-2">
                            <img src="@/assets/icon/icon-success.png" />
                        </div>
                        <span
                            class="text-header">
                            {{ head }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                {{ msg }}
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            plain
                            @click="submitBtn()">
                                {{ this.$vuetify.lang.t('$vuetify.checkInOnsite.confirm') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            dialog: false
        }
    },
    props: {
        head: {
            type: String,
            default: 'Success'
        },
        msg: {
            type: String,
            default: ''
        },
        textBtn: {
            type: String,
            default: ''
        }
    },
    methods: {
        submitBtn () {
            this.$emit('ok-submit')
            this.dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
img {
    width: 24px;
    height: 24px;
}
.text-header {
    font-size: 18px;
}
</style>
